module.exports = __webpack_public_path__ + "img/payment_partners.b6ed71eb.png";